import ContactDTO from 'features/customer/dtos/ContactDTO';
import FormGroup from 'features/shared/forms/components/FormGroup';
import React, { useEffect, useState } from 'react';
import { ActionMeta } from "react-select";
import reactSelectStyles from 'features/shared/components/reactSelect/reactselectcustom.module.scss';
import CreatableSelect from 'react-select/creatable';
import { createFilter } from "react-select";
import { Nullable } from 'features/shared/types/nullable';
import { Config } from 'react-select/src/filters';
import { useTranslation } from 'react-i18next';

// types
interface OptionType {
  value: string;
  label: string;
};

export interface SelectedValue {
  action: "select" | "create";
  option: OptionType;
}

interface Props {
  name: string;
  emails: ContactDTO[];
  onChange: (email: SelectedValue) => void;
  errors?: Record<string, string>;
}

// component
const AvailableEmailSelect = ({ name, emails, onChange, errors}: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // state
  const [options, setOptions] = useState<OptionType[]>([]);

  // side effects
  useEffect(() => {
    convertEmailsToOptions();
  }, [emails]);

  // helpers
  const convertEmailsToOptions = () => {
    const res = emails.map((contact) => {
      return {
        value: contact.contactId,
        label: contact.value
      } as OptionType
    });

    setOptions(res);
  }

  // filter setting
  const filterConfig: Config = {
    stringify: (obj: any) => {
      const { label } = obj.data as OptionType;
      return `${label}`;
    }
  };

  // handlers
  const emailChangeHandler = (value: Nullable<OptionType>, action: ActionMeta<OptionType>) => {
    if (value) {
      if (action.action == "create-option") {
        onChange({
          action: "create",
          option: value as OptionType
        });
      } else if (action.action == "select-option") {
        onChange({
          action: "select",
          option: value as OptionType
        });
      }   
    }
  }

  // render
  return (
    <FormGroup labelText={tLabels("availableEmailSelect.email")} validationError={errors ? errors[name] : undefined}>
      <CreatableSelect 
        options={options}
        onChange={emailChangeHandler}
        filterOption={createFilter(filterConfig)}
        captureMenuScroll={false}
        className={reactSelectStyles.customSelect}
        classNamePrefix="customSelect"
        formatCreateLabel={userInput => `${tLabels("availableEmailSelect.newEmail")}: ${userInput}`}
        placeholder={tLabels("availableEmailSelect.setNewEmail")}
        noOptionsMessage={() => tLabels("availableEmailSelect.message")}
      />
    </FormGroup>
  )
}

export default AvailableEmailSelect;
